import { SET_ALLERGENS } from "../actions";

export function setAllergens(payload) {
  return {
    type: SET_ALLERGENS,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/allergens.js